import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Briefcase } from 'lucide-react';

const CareersPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const jobs = [
    { title: 'Frontend Developer', department: 'Engineering', type: 'Full-time', location: 'Remote' },
    { title: 'Vendor Onboarding Specialist', department: 'Operations', type: 'Full-time', location: 'Mumbai, India' },
    { title: 'Renewable Energy Analyst', department: 'Strategy', type: 'Full-time', location: 'Bangalore, India' },
    { title: 'Customer Support Lead', department: 'Support', type: 'Full-time', location: 'Remote' },
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow pt-24 bg-background">
        <div className="container-solar py-12 md:py-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
              Build the Future of <span className="solar-text-gradient">Energy</span>
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Ready to make an impact? Join our team of innovators and help accelerate the world's transition to sustainable energy.
            </p>
          </motion.div>

          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold mb-8 flex items-center gap-3">
              <Briefcase className="text-primary w-6 h-6" /> Open Positions
            </h2>
            
            <div className="space-y-4">
              {jobs.map((job, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: i * 0.1 }}
                  className="bg-card hover:bg-secondary/20 border border-border p-6 rounded-2xl transition-all flex flex-col md:flex-row md:items-center justify-between gap-4 cursor-pointer group"
                >
                  <div>
                    <h3 className="text-xl font-bold text-foreground mb-2 group-hover:text-primary transition-colors">{job.title}</h3>
                    <div className="flex flex-wrap gap-3 text-sm text-muted-foreground">
                      <span className="bg-secondary px-3 py-1 rounded-full">{job.department}</span>
                      <span className="flex items-center">{job.type}</span>
                      <span className="flex items-center">{job.location}</span>
                    </div>
                  </div>
                  <button className="flex items-center gap-2 text-primary font-medium group-hover:translate-x-2 transition-transform">
                    Apply Now <ArrowRight className="w-4 h-4" />
                  </button>
                </motion.div>
              ))}
            </div>

            <div className="mt-16 bg-primary/10 rounded-3xl p-8 text-center border border-primary/20">
              <h3 className="text-xl font-bold mb-3">Don't see a perfect fit?</h3>
              <p className="text-muted-foreground mb-6">
                We're always looking for talented individuals. Send your resume to <a href="mailto:careers@solarsavers.com" className="text-primary font-medium hover:underline">careers@solarsavers.com</a>
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CareersPage;
